import api from "@/lib/api";

export default {
  getById(id) {
    return api.get("/api/v1/shared/expense/get-by-id", { params: { id } });
  },
  getAll(genericId, rentId) {
    return api.get("/api/v1/shared/expense/get-all", { params: { any: genericId, rentId } });
  },
  create(expense) {
    return api.post("/api/v1/shared/expense/create", expense);
  },
  update(expense) {
    return api.put("/api/v1/shared/expense/update", expense);
  },
  remove(id) {
    const ids = Array.isArray(id) ? id.join(",") : id;
    return api.delete("/api/v1/shared/expense/delete", { params: { ids } });
  },
};
